export const dedupeById = (rows = []) => {
  const seen = new Set();
  return rows.filter((row) => {
    if (!row?.id) return true;
    if (seen.has(row.id)) return false;
    seen.add(row.id);
    return true;
  });
};

export const mergeReport = (existingReport, incomingReport, incomingValues) => {
  const base = existingReport || {};
  const incoming = incomingReport || {};
  const mergedValues =
    incomingValues !== undefined
      ? dedupeById(incomingValues)
      : incoming.values
      ? dedupeById(incoming.values)
      : base.values || [];
  const mergedScenarios = incoming.economic_scenarios
    ? dedupeById(incoming.economic_scenarios)
    : base.economic_scenarios || [];
  return {
    ...base,
    ...incoming,
    values: mergedValues,
    economic_scenarios: mergedScenarios,
  };
};
